import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import { Toast } from "antd-mobile";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { coinApi } from "../../api/coin-api";
import { financeApi } from "../../api/finance-api";
import { getText } from "../../utils/util";
import TopPage from "./components/topPage";

export default function AddressAdd() {
  const navigate = useNavigate();
  const uid = localStorage.getItem("uid");
  const [addressList, setAddressList] = useState([] as any[]);
  const [coinList, setCoinList] = useState([] as any[]);
  const { t: translate } = useTranslation();
  const isMounted = useRef(true);

  //加载数据
  const loadData = async () => {
    loadAddressData();
    loadCoinData();
  };

  //加载地址
  const loadAddressData = async () => {
    if (!isMounted.current) return;
    try {
      const data = await financeApi.list({ uid });
      if (data.ok && isMounted.current) {
        setAddressList(data.data);
      }
    } catch (error) {
      // 处理错误但不阻止组件运行
      console.error("加载地址数据出错:", error);
    }
  };

  //加载种类
  const loadCoinData = async () => {
    if (!isMounted.current) return;
    try {
      const data = await coinApi.list();
      if (data.ok && isMounted.current) {
        setCoinList(data.data);
      }
    } catch (error) {
      // 处理错误但不阻止组件运行
      console.error("加载币种数据出错:", error);
    }
  };

  //添加地址
  const addAddress = async (address) => {
    if (!isMounted.current) return;
    try {
      const data = await financeApi.add({ uid, ...address });
      if (data.ok) {
        Toast.show({
          content: translate(getText("操作成功")),
        });
        navigate(-1);
      } else {
        Toast.show({
          content: translate(getText("系統錯誤")),
        });
      }
      if (isMounted.current) {
        loadAddressData();
      }
    } catch (error) {
      console.error("添加地址出错:", error);
      Toast.show({
        content: translate(getText("系統錯誤")),
      });
    }
  };
  
  //删除 地址
  const delAddress = async (id) => {
    if (!isMounted.current) return;
    try {
      const data = await financeApi.del({ id });
      if (data.ok) {
        Toast.show({
          content: translate(getText("操作成功")),
        });
      } else {
        Toast.show({
          content: translate(getText("系統錯誤")),
        });
      }
      if (isMounted.current) {
        loadAddressData();
      }
    } catch (error) {
      console.error("删除地址出错:", error);
      Toast.show({
        content: translate(getText("系統錯誤")),
      });
    }
  };

  useEffect(() => {
    loadData();
    
    return () => {
      isMounted.current = false;
    };
  }, []);
  
  return (
    <div className="w-full min-h-dvh bg-neutral-900 revert-style">
      <AcendexLayout
        theme="light"
        hideBottomBar
        mobileTopBarTitle={translate(getText("添加钱包地址"))}
        pcTopBarTitle={translate(getText("添加钱包地址"))}
      >
        <div className="max-w-screen-lg mx-auto px-4 py-6">
          <TopPage
            coinList={coinList}
            addAddress={addAddress}
            delAddress={delAddress}
          />
        </div>
      </AcendexLayout>
    </div>
  );
}
